<template>
  <div>
    <!-- 主弹窗部分 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="finalVisible"
      width="700px"
    >
      <el-form ref="cinemaForm" v-loading="loading"
               :model="formData"
               :rules="rules"
               label-width="100px">
        <!-- 分类名称 -->
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="formData.name" maxlength="32" placeholder="请输入分类名称" show-word-limit/>
        </el-form-item>

        <!-- 影院搜索选择 -->
        <el-form-item label="影院" prop="cinemaNames">
          <el-card v-if="formData.cinemaList.length > 0" shadow="hover">
            <div slot="header" class="cinema-header">
              <div>
                <el-icon>
                  <CheckCircle/>
                </el-icon>
                <span> 已添加影院 ({{ formData.cinemaList.length }})</span>
              </div>
              <el-input
                v-model="cinemaSearchQuery"
                class="cinema-search-input"
                clearable
                placeholder="搜索影院"
                @input="handleCinemaSearch"
              />
            </div>
            <div class="result-card">
              <el-tag
                v-for="(cinema, index) in filteredCinemaList"
                :key="index"
                class="tag-item"
                closable
                style="margin: 4px"
                type="success"
                @close="handleRemoveCinema(cinema)"
              >
                {{ cinema.cinemaName }}
              </el-tag>
            </div>
          </el-card>
          <el-link type="primary" @click="showImportDialog">影资编码导入</el-link>
          <el-link type="danger" @click="clearSelection">清空</el-link>
        </el-form-item>

        <!-- 已删除影院列表 -->
        <el-form-item v-if="removedCinemaList.length > 0" label="已删除影院">
          <el-card shadow="hover">
            <div slot="header" class="cinema-header">
              <div>
                <el-icon>
                  <DeleteFilled/>
                </el-icon>
                <span> 已删除影院 ({{ removedCinemaList.length }})</span>
              </div>
            </div>
            <div class="result-card">
              <el-tag
                v-for="(cinema, index) in removedCinemaList"
                :key="index"
                class="tag-item"
                closable
                style="margin: 4px"
                type="info"
                @close="handleRestoreCinema(cinema)"
              >
                {{ cinema.cinemaName }}
              </el-tag>
            </div>
          </el-card>
        </el-form-item>

        <!-- 状态开关 -->
        <el-form-item label="状态">
          <el-switch v-model="formData.status" :active-value="1" :inactive-value="0"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button :disabled="submitLoading" :loading="submitLoading" type="primary" @click="handleSubmit">确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 影资编码导入的子弹窗 -->
    <dd-cinema-management-import-dialog
      :cinema-map-by-standard-id="cinemaMapByStandardId"
      :loading="loading"
      :standard-ids="formData.standardId"
      :visible.sync="importDialogVisible"
      @confirm="handleImportConfirm"
    />
  </div>
</template>

<script>
import mini from "@/api/mini";
import DdCinemaManagementImportDialog from "./ddCinemaManagementImportDialog.vue"; // 导入影资编码导入弹窗组件

const MiniModel = new mini();

export default {
  name: "ddCinemaManagementFormDialog",
  components: {
    DdCinemaManagementImportDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        id: null, // 用于判断是新增还是编辑
        name: "", // 分类名称
        cinemaList: [], // 影院列表
        status: 0, // 状态
        cinemaName: '',
        standardId: '',
      },
      loading: false,
      submitLoading: false,
      cinemaOptions: [], // 搜索到的影院选项
      importDialogVisible: false, // 控制影资编码导入弹窗的显示
      cinemaMapByStandardId: {},
      rules: {
        name: [{required: true, message: "请输入分类名称", trigger: "blur"}],
        cinemaName: [{required: true, message: "请导入影院", trigger: "blur"}],
      },
      cinemaSearchQuery: "", // 搜索输入框的值
      removedCinemaList: [], // 已删除的影院名称数组
      removedStandards: [], // 已删除的影资编码数组
    };
  },
  computed: {
    finalVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    dialogTitle() {
      return this.formData.id ? "编辑影院分类" : "新建影院分类";
    },
    filteredCinemaList() {
      // 根据搜索条件过滤影院名称
      if (!this.cinemaSearchQuery) {
        return this.formData.cinemaList;
      }
      return this.formData.cinemaList.filter(cinema =>
        cinema.cinemaName.toLowerCase().includes(this.cinemaSearchQuery.toLowerCase())
      );
    },
  },
  watch: {
    initialData: {
      handler(newValue) {
        if (Object.keys(newValue).length) {
          this.formData.id = newValue.id;
          this.formData.name = newValue.name;
          this.formData.status = newValue.status;
          this.formData.standardId = newValue.standardId;
          this.formData.cinemaName = newValue.cinemaName;
          if (Object.keys(this.cinemaMapByStandardId).length) {
            const standardIds = newValue.standardId.split(",");
            const finalCinemaList = []
            standardIds.forEach((standardId) => {
              if (this.cinemaMapByStandardId[standardId]) {
                finalCinemaList.push(this.cinemaMapByStandardId[standardId]);
              }
            });
            this.formData.cinemaList = [...finalCinemaList];
          }
        } else {
          this.formData.id = null;
          this.formData.name = "";
          this.formData.status = 0;
          this.formData.standardId = '';
          this.formData.cinemaName = '';
          this.formData.cinemaList = [];
        }
      },
      immediate: true,
      deep: true,
    },
    visible: {
      handler(val) {
        if (val) {
          this.removedCinemaList = [];
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchCinemaList()
  },
  methods: {
    handleImportConfirm(result) {
      console.log("debug:________________result______________", result);
      // 处理影资编码导入确认逻辑
      this.$set(this.formData, "cinemaList", [...result.successList]);
    },
    fetchCinemaList() {
      this.loading = true;
      MiniModel.dyCinemaList({cinemaName: ''})
        .then((res) => {
          if (res.data.code === 200) {
            res.data.data.forEach((item) => {
              this.cinemaMapByStandardId[item.standardId] = {
                cinemaName: item.cinemaName,
                standardId: item.standardId,
              };
            });
            if (Object.keys(this.initialData).length) {
              const standardIds = this.initialData.standardId.split(",");
              const finalCinemaList = []
              standardIds.forEach((standardId) => {
                if (this.cinemaMapByStandardId[standardId]) {
                  finalCinemaList.push(this.cinemaMapByStandardId[standardId]);
                }
              });
              this.formData.cinemaList = [...finalCinemaList];
            }
            this.loading = false
          } else {
            this.$message.error(res.data.info);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCinemaSearch() {
      // 处理搜索输入变化
      // 这里可以扩展实现复杂的搜索逻辑，目前只更新cinemaSearchQuery来过滤影院列表
    },
    handleRemoveCinema(cinema) {
      // 处理删除影资编码时的同步删除影院名称
      this.removedCinemaList.push(cinema);
      this.formData.cinemaList = this.formData.cinemaList.filter((item) => cinema.standardId !== item.standardId);
    },
    handleRestoreCinema(cinema) {
      this.formData.cinemaList.push(cinema);
      this.removedCinemaList = this.removedCinemaList.filter((item) => item.standardId !== cinema.standardId);
    },
    showImportDialog() {
      // 显示影资编码导入弹窗
      this.importDialogVisible = true;
    },
    clearSelection() {
      this.formData.cinemaList = []
    },
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleSubmit() {
      this.submitLoading = true;
      if (this.formData.cinemaList.length === 0) {
        this.$message.error("请导入影院");
        this.submitLoading = false;
        return;
      }
      this.$refs.cinemaForm.validate((valid) => {
        if (valid) {
          const apiMethod = (this.formData.id ? MiniModel.dyCinemaEdit : MiniModel.dyCinemaAdd).bind(MiniModel);
          apiMethod({
            ...this.formData,
            standardId: this.formData.cinemaList.map((item) => item.standardId).join(","),
            cinemaName: this.formData.cinemaList.map((item) => item.cinemaName).join(","),
          })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success("操作成功");
                this.$emit("update:visible", false);
                this.$emit("refreshData");
              } else {
                this.$message.error(res.data.info);
              }
            })
            .catch(() => {
              this.$message.error("操作失败，请重试");
            }).finally(() => {
            this.submitLoading = false;
          });
        } else {
          this.submitLoading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end; /* 按钮右对齐 */
}

.result-card {
  max-height: 200px;
  overflow-y: auto;
}

.cinema-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
}

.cinema-search-input {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/ddCouponExchange/ddCinemaManagement/components/ddCinemaManagementFormDialog.vue